/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../../services/toast';
export default {
  name: 'account-su-updates-list',
  components: {},
  props: [],
  data () {
    return {
      updatesList:{},
      nextStep:'',
      updatesListResults:[],
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      DeleteId:'',
      checkDataTaskModal:false
    }
  },
  computed: {
  ...mapGetters([
    'getSuAcUpdatesListGetters'
  ]),
  getUpdateListDetailsFun(){
    return this.updatesList = this.$store.getters.getSuAcUpdatesListGetters.data
  },
  SetIntialStatus() {
    if (this.updatesList != undefined) {
      this.nextStep = this.updatesList.next
      this.updatesListResults = this.updatesList.results
    }
  }
  },
  mounted () {
    this.getUpdateListDetailsFun
    this.SetIntialStatus
  },
  methods: {
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.updatesList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.updatesListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getRemoveListAgain() {
      this.$store.dispatch('getSuAcUpdatesListFun').then((res) => {
        this.updatesList = this.$store.getters.getSuAcUpdatesListGetters.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("task_modal_actv");
      this.checkDataTaskModal = true
      this.DeleteId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeSuAcUpdatesListFun', {
        id: this.DeleteId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("task_modal_actv");
          this.getRemoveListAgain()
          this.checkDataTaskModal = false
          this.DeleteId = ''
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("task_modal_actv");
      this.checkDataTaskModal = false
      this.taskDeleteId = ''
    }
  },
  watch:{
    getUpdateListDetailsFun(){
      return this.updatesList = this.$store.getters.getSuAcUpdatesListGetters.data
    },
    SetIntialStatus() {
      if (this.updatesList != undefined) {
        this.nextStep = this.updatesList.next
        this.updatesListResults = this.updatesList.results
      }
    }
  }
}


